/* floating-bar.js — desktop unchanged; mobile hides title/compare and moves regular price to right
   + Back-to-top button integrated
   (ONLY additions: sold-out label toggling + keep existing availability guard)
*/
(function(){
  if(!/\/products\//.test(window.location.pathname)) return;

  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){

    /* --- CSS injected into document --- */
    var css = "\
.floating-product-bar{position:fixed;left:0px;right:0px;bottom:0px;margin:0 auto;max-width:3000px;background:#fff;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,0.12);display:flex;align-items:center;justify-content:space-between;padding:10px 14px;transform:translateY(120%);transition:transform 300ms cubic-bezier(.2,.9,.2,1),opacity 200ms;opacity:0;z-index:12000;gap:12px}\
.floating-product-bar.visible{transform:translateY(0);opacity:1}\
.fp-left{display:flex;flex-direction:column;gap:4px;min-width:0;flex:1 1 auto}\
.fp-title{font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60ch;color:#111}\
.fp-price{font-weight:700;color:#111;font-size:13px}\
.fp-compare{font-size:12px;color:#888;text-decoration:line-through;opacity:0.9}\
.fp-actions{display:flex;align-items:center;gap:10px;margin-left:12px}\
.fp-qty{display:flex;align-items:center;border:1px solid #e0e0e0;border-radius:8px;overflow:hidden;background:#fff}\
.fp-qty input{width:56px;text-align:center;border:0;padding:6px;font-size:14px;outline:none}\
.fp-qty-btn{border:0;padding:6px 10px;cursor:pointer;font-weight:700;min-width:44px;display:flex;align-items:center;justify-content:center;font-size:18px}\
#fp-increase.fp-qty-btn{background:#137a35;color:#fff;border-radius:0 6px 6px 0}\
#fp-decrease.fp-qty-btn{background:#e02424;color:#fff;border-radius:6px 0 0 6px}\
#fp-increase.fp-qty-btn:hover,#fp-decrease.fp-qty-btn:hover{filter:brightness(0.92)}\
.fp-add{background:#ff5253;color: white; border:0;padding:10px 16px;border-radius:8px;font-weight:800;cursor:pointer;white-space:nowrap}\\\
/* ensure button does not shrink beside long content */\
.fp-add{flex:0 0 auto}\
/* class used when price is displayed inside actions on mobile */\
.fp-price--in-actions{margin:0 6px;white-space:nowrap;font-weight:700;font-size:14px}\
/* ---------------- Mobile-specific: hide title+compare and position price to right ---------------- */\
@media (max-width:520px){\
  .floating-product-bar{flex-direction:column;align-items:stretch;padding:8px;bottom:0px;left:8px;right:8px;gap:8px}\
  /* hide title + compare on mobile */\
  .fp-title{display:none !important}\
  .fp-compare{display:none !important}\
  /* keep left container but we will move the price into actions via JS; left is kept (empty) */\
  .fp-left{flex-direction:row;justify-content:flex-end;width:100%}\
  .fp-price{display:block;font-size:15px;color:#111;margin-left:auto}\
  .fp-actions{display:flex;align-items:center;gap:8px;margin-left:0;align-items:center;justify-content:space-between;width:100%}\
  .fp-qty{flex:0 0 auto;margin-left:0}\
  .fp-qty input{width:46px;padding:5px;font-size:13px}\
  .fp-add{flex:0 1 auto;margin-left:6px;max-width:56%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:10px 12px;font-size:12px}\
}\
@media (max-width:380px){\
  .fp-add{flex:0 0 110px;padding:8px;font-size:12px}\
  .fp-qty input{width:42px;font-size:13px}\
}\
/* Back-to-top button styles (appears above floating bar) */\
#fp-back-to-top{position:fixed;left:38px;bottom:calc(120px + 12px);z-index:12001;display:flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:999px;background:black;color:#fff;font-weight:700;box-shadow:0 8px 22px rgba(0,0,0,0.15);cursor:pointer;opacity:0;transform:translateY(8px);transition:opacity 200ms,transform 200ms;border:0}\
#fp-back-to-top:focus{outline:3px solid rgba(19,122,53,0.18)}\
#fp-back-to-top.show{opacity:1;transform:translateY(0)}\
@media (max-width:520px){\
  #fp-back-to-top{left:14px;width:40px;height:40px;bottom:calc( (var(--fp-bar-height, 72px)) + 10px )}\
}\
/* --- Add-to-cart up/down animations --- */\
.fp-add { transition: transform 0.25s ease; }\
/* hover still triggers the up/down dance */\
.fp-add:hover { animation: fpAddDanceY 0.6s ease-in-out infinite; }\
/* continuous up/down dance when bar is visible */\
.fp-add.fp-dance { animation: fpAddDanceY 0.6s ease-in-out infinite; }\
@keyframes fpAddDanceY {\
  0%   { transform: translateY(0); }\
  25%  { transform: translateY(-6px); }\
  50%  { transform: translateY(0); }\
  75%  { transform: translateY(-4px); }\
  100% { transform: translateY(0); }\
}\
";

    var s = document.createElement('style');
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);


    /* --- Floating bar HTML --- */
    var bar = document.createElement('div');
    bar.id = 'floatingProductBar';
    bar.className = 'floating-product-bar';
    bar.setAttribute('aria-hidden', 'true');

    bar.innerHTML =
      '<div class=\"fp-left\">'+
      '  <div class=\"fp-title\" id=\"fp-product-title\"></div>'+
      '  <div class=\"fp-price\" id=\"fp-product-price\"></div>'+
      '  <div class=\"fp-compare\" id=\"fp-product-compare\"></div>'+
      '</div>'+
      '<div class=\"fp-actions\">'+
      '  <div class=\"fp-qty\">'+
      '    <button class=\"fp-qty-btn\" id=\"fp-decrease\" aria-label=\"Decrease quantity\">−</button>'+ 
      '    <input id=\"fp-qty-input\" type=\"number\" value=\"1\" min=\"1\" aria-label=\"Quantity\">'+
      '    <button class=\"fp-qty-btn\" id=\"fp-increase\" aria-label=\"Increase quantity\">+</button>'+
      '  </div>'+
      '  <button id=\"fp-add-to-cart\" class=\"fp-add\">ADD TO CART</button>'+
      '</div>';

    document.body.appendChild(bar);


    /* --- JS elements --- */
    var addBtn = document.getElementById('fp-add-to-cart');
    var qtyInput = document.getElementById('fp-qty-input');
    var inc = document.getElementById('fp-increase');
    var dec = document.getElementById('fp-decrease');
    var titleEl = document.getElementById('fp-product-title');
    var priceEl = document.getElementById('fp-product-price');
    var compareEl = document.getElementById('fp-product-compare');
    var fpLeft = document.querySelector('#floatingProductBar .fp-left');
    var fpActions = document.querySelector('#floatingProductBar .fp-actions');


    /* --- Product title (desktop) --- */
    var pageTitle = document.querySelector('h1') ? document.querySelector('h1').innerText.trim() : (document.title || '');
    titleEl.textContent = pageTitle;


    /* --- Read regular price & compare price from theme --- */
    function readPrices(){
      // regular price (theme variants)
      var regEl =
        document.querySelector('.price__regular .price-item--regular') ||
        document.querySelector('.product__price .price-item--regular') ||
        document.querySelector('.price-item--regular') ||
        document.querySelector('[data-regular-price]') ||
        document.querySelector('.price'); // fallback

      var regText = regEl ? (regEl.innerText || regEl.textContent || '').trim() : '';

      // compare/was price (common selectors)
      var cmpEl =
        document.querySelector('.price--compare, .price__compare, .compare-price, .price--was, .was-price, [data-compare-price]') ||
        document.querySelector('.price--old, .price__old');

      var cmpText = '';
      if(cmpEl){
        cmpText = (cmpEl.innerText || cmpEl.textContent || '').trim();
        if(cmpText === regText) cmpText = '';
      }

      return { regular: regText, compare: cmpText };
    }

    var initialPrices = readPrices();
    priceEl.textContent = initialPrices.regular || '';
    compareEl.textContent = initialPrices.compare || '';


    /* --- Quantity buttons --- */
    inc.addEventListener('click', function(){
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1);
    });

    dec.addEventListener('click', function(){
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
    });


    /* --- Show / hide bar logic --- */
    var shown = false;
    function showBar(){
      if(!shown){
        bar.classList.add('visible');
        bar.setAttribute('aria-hidden','false');
        // start dancing when bar visible
        try { if(addBtn) addBtn.classList.add('fp-dance'); } catch(e){}
        shown = true;
      }
    }
    function hideBar(){
      if(shown){
        bar.classList.remove('visible');
        bar.setAttribute('aria-hidden','true');
        // stop dancing when hidden
        try { if(addBtn) addBtn.classList.remove('fp-dance'); } catch(e){}
        shown = false;
      }
    }
    window.addEventListener('scroll', function(){
      var sc = window.scrollY || window.pageYOffset;
      if(sc > 120) showBar();
      else hideBar();
    }, {passive:true});

    // if page already scrolled when loaded, show & start dance
    if((window.scrollY || window.pageYOffset) > 120){
      showBar();
    }


    /* --- IntersectionObserver on product section --- */
    var observed = document.querySelector('.product-single')
      || document.querySelector('#MainProduct')
      || document.querySelector('.product-template')
      || document.querySelector('[data-product]');
    if(observed){
      var io = new IntersectionObserver(function(entries){
        var e = entries[0];
        if(!e.isIntersecting || e.intersectionRatio < 1){
          showBar();
        } else {
          if((window.scrollY || window.pageYOffset) < 120) hideBar();
        }
      }, {threshold:[0,0.5,1]});
      io.observe(observed);
    }


    /* --- Detect selected variant ID --- */
    function getSelectedVariantId(){
      var idInput = document.querySelector('form[action^=\"/cart/add\"] input[name=\"id\"], form#AddToCartForm input[name=\"id\"]');
      if(idInput && idInput.value) return idInput.value;
      var sel = document.querySelector('select[name=\"id\"]');
      if(sel && sel.value) return sel.value;
      var id2 = document.querySelector('input[name=\"variantId\"], input[data-variant-id]');
      if(id2 && id2.value) return id2.value;
      try { if(window.product && window.product.variants && window.product.variants[0]) return window.product.variants[0].id; } catch(e){}
      return null;
    }


    /* --- Add to cart (patched: checks variant availability before posting) --- */
    function isVariantAvailable(variantId){
      if(!variantId) return false;

      // 1) Check window.product.variants[*].available (most reliable)
      try {
        if(window.product && Array.isArray(window.product.variants)){
          for(var i=0;i<window.product.variants.length;i++){
            var v = window.product.variants[i];
            if(String(v.id) === String(variantId) || String(v.id) === String(Number(variantId))){
              if(typeof v.available !== 'undefined') return !!v.available;
            }
          }
        }
      } catch(e){ /* ignore */ }

      // 2) Check select option attributes (some themes disable sold-out options)
      try {
        var sel = document.querySelector('select[name=\"id\"]');
        if(sel){
          var opt = sel.querySelector('option[value=\"' + variantId + '\"]');
          if(opt){
            if(opt.disabled) return false;
            var da = opt.getAttribute('data-available');
            if(da !== null) return !(da === 'false' || da === '0');
            var ds = opt.getAttribute('data-sold-out');
            if(ds !== null) return !(ds === 'true' || ds === '1');
          }
        }
      } catch(e){ /* ignore */ }

      // 3) Check page add button state/text (some themes disable their own add button)
      try {
        var pageAdd = document.querySelector('form[action^=\"/cart/add\"] button, form[action^=\"/cart/add\"] input[type=\"submit\"], button.add-to-cart, [data-add-to-cart]');
        if(pageAdd){
          if(pageAdd.disabled) return false;
          var txt = (pageAdd.innerText || pageAdd.value || '').toLowerCase();
          if(/sold out|out of stock|unavailable/.test(txt)) return false;
        }
      } catch(e){ /* ignore */ }

      // 4) Fallback: unknown => assume available (can't determine)
      return true;
    }

    // === NEW: toggle button label + disabled state based on selected variant availability ===
    // store original add text to restore later
    var origAddText = (addBtn && addBtn.textContent) ? addBtn.textContent.trim() : 'ADD TO CART';

    function setButtonSoldOutState(){
      if(!addBtn) return;
      addBtn.textContent = 'SOLD OUT';
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
      // keep dance off when sold out
      try { addBtn.classList.remove('fp-dance'); } catch(e){}
    }

    function setButtonAddState(){
      if(!addBtn) return;
      addBtn.textContent = origAddText;
      addBtn.disabled = false;
      addBtn.removeAttribute('aria-disabled');
      // if bar visible, ensure dance class present (keep existing behavior)
      try { if(shown) addBtn.classList.add('fp-dance'); } catch(e){}
    }

    function updateAddButtonState(){
      var variantId = getSelectedVariantId();
      if(!variantId){
        // if no variant (single-variant product), decide by reading page add button if possible
        // fallback: enable
        setButtonAddState();
        return;
      }
      var avail = isVariantAvailable(variantId);
      if(!avail) setButtonSoldOutState();
      else setButtonAddState();
    }

    // Run initially (after DOM elements created)
    setTimeout(updateAddButtonState, 60);

    // Listen for variant selection changes:
    // - select[name="id"] change
    // - radio/inputs that might store variantId
    // - custom events from theme (some themes fire 'variant:change' or 'variantChange' or 'product:variant:changed')
    document.addEventListener('change', function(e){
      var t = e.target;
      if(!t) return;
      if(t.matches && (t.matches('select[name="id"]') || t.matches('input[name="id"]') || t.matches('input[name="variantId"]') || t.matches('input[data-variant-id]'))){
        setTimeout(updateAddButtonState, 40);
      }
    }, {passive:true});

    document.addEventListener('click', function(e){
      // some themes toggle variant via clickable buttons; re-check after click
      setTimeout(updateAddButtonState, 80);
    }, {passive:true});

    // Listen for common theme events (non-standard but many themes use custom events)
    window.addEventListener('variant:change', updateAddButtonState);
    window.addEventListener('variantChange', updateAddButtonState);
    window.addEventListener('product:variant:changed', updateAddButtonState);
    window.addEventListener('variant:changed', updateAddButtonState);

    // MutationObserver to catch programmatic updates to inputs (robust fallback)
    try {
      var variantObserverTarget = document.querySelector('form[action^="/cart/add"]') || document.body;
      var moVariant = new MutationObserver(function(muts){
        // small debounce
        clearTimeout(window.__fp_variant_update_to);
        window.__fp_variant_update_to = setTimeout(updateAddButtonState, 60);
      });
      moVariant.observe(variantObserverTarget, {childList:true, subtree:true, attributes:true, attributeFilter: ['value', 'disabled', 'data-available', 'data-sold-out']});
    } catch(e){ /* ignore if observer fails */ }

    // === end new toggle logic ===

    // Replace add button handler with availability check (existing logic; unchanged except using new button state)
    try {
      if(addBtn){
        // remove any existing listeners by cloning (safer in some environments), then reassign variable
        var addBtnClone = addBtn.cloneNode(true);
        addBtn.parentNode.replaceChild(addBtnClone, addBtn);
        addBtn = document.getElementById('fp-add-to-cart');
        // restore origAddText from cloned node (in case clone changed)
        origAddText = (addBtn && addBtn.textContent) ? addBtn.textContent.trim() : origAddText;
      }
    } catch(e){ /* ignore clone step if it fails */ }

    if(addBtn){
      addBtn.addEventListener('click', function(){
        var variantId = getSelectedVariantId();
        if(!variantId){
          alert('Please select variant on the page first.');
          return;
        }

        // availability guard
        if(!isVariantAvailable(variantId)){
          alert('This variant is currently sold out and cannot be added to cart.');
          // ensure button state is correct
          updateAddButtonState();
          return;
        }

        var qty = Math.max(1, parseInt(qtyInput.value || 1, 10));
        addBtn.disabled = true;
        var origText = addBtn.textContent;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json','Accept':'application/json' },
          body: JSON.stringify({id: variantId, quantity: qty})
        })
        .then(function(r){
          if(!r.ok) throw r;
          return r.json();
        })
        .then(function(data){
          addBtn.textContent = 'Added ✓';
          setTimeout(function(){
            addBtn.textContent = origText;
            addBtn.disabled = false;
            // re-check availability and update label (in case inventory changed)
            setTimeout(updateAddButtonState, 60);
          }, 900);
          window.dispatchEvent(new CustomEvent('cart:added', {detail: data}));
        })
        .catch(function(err){
          console.error(err);
          addBtn.disabled = false;
          addBtn.textContent = origText;
          alert('Could not add to cart.');
          // re-check availability
          setTimeout(updateAddButtonState, 60);
        });
      });
    }

    /* --- Auto-update price + compare when theme updates DOM --- */
    var priceObserve = document.querySelector('.price') || document.querySelector('[data-product-price]') || document.querySelector('.product__price') || document.querySelector('.price-item--regular');
    if(priceObserve){
      var mo = new MutationObserver(function(){
        var p = readPrices();
        priceEl.textContent = p.regular;
        compareEl.textContent = p.compare;
        // prices/DOM changed - variant availability might have changed too
        updateAddButtonState();
      });
      mo.observe(priceObserve, {childList:true, subtree:true, characterData:true});
    }


    /* --- MOBILE: move only the regular price element into actions on mobile so price appears right --- */
    function positionPriceForViewport(){
      var mobile = window.matchMedia('(max-width:520px)').matches;
      // ensure we have nodes
      if(!priceEl || !fpLeft || !fpActions) return;
      if(mobile){
        // if price not yet in actions, move it before add button
        if(priceEl.parentElement !== fpActions){
          // create a clone wrapper so we can move the node safely
          try { fpActions.insertBefore(priceEl, addBtn); priceEl.classList.add('fp-price--in-actions'); }
          catch(e){}
        }
      } else {
        // move back into left area if currently inside actions
        if(priceEl.parentElement !== fpLeft){
          try { fpLeft.insertBefore(priceEl, fpLeft.firstChild); priceEl.classList.remove('fp-price--in-actions'); }
          catch(e){}
        }
      }
    }

    // initial position
    positionPriceForViewport();

    // reposition on resize/orientation (debounced)
    var rt = null;
    window.addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(positionPriceForViewport, 120);
    }, {passive:true});
    window.addEventListener('orientationchange', function(){ setTimeout(positionPriceForViewport, 120); }, false);


    /* === Back-to-top button: placed to appear just above floating bar === */

    /* create the button element (only once) */
    if(!document.getElementById('fp-back-to-top')){
      var backBtn = document.createElement('button');
      backBtn.id = 'fp-back-to-top';
      backBtn.type = 'button';
      backBtn.setAttribute('aria-label', 'Back to top');
      backBtn.setAttribute('aria-hidden', 'true');
      backBtn.innerHTML = '↑'; // simple arrow — replace with SVG if desired
      document.body.appendChild(backBtn);
    } else {
      var backBtn = document.getElementById('fp-back-to-top');
    }

    /* helper: scroll target (product section if available) */
    var productTopEl = observed || document.querySelector('.product-single') || document.querySelector('#MainProduct') || document.querySelector('.product-template') || document.querySelector('[data-product]');

    /* smooth scroll behavior */
    backBtn.addEventListener('click', function(e){
      e.preventDefault();
      var targetY = 0;
      if(productTopEl){
        // scroll to top of product section (account for any sticky header by offsetting if needed)
        var rect = productTopEl.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        targetY = Math.max(0, rect.top + scrollTop - 16); // small offset, tweak if header covers content
      }
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    });

    /* position the button just above the floating bar (dynamic) */
    function updateBackBtnPosition(){
      // measure current floating bar height (if visible in DOM)
      var barRect = bar && bar.getBoundingClientRect ? bar.getBoundingClientRect() : null;
      var height = barRect && barRect.height ? barRect.height : 72; // fallback
      // set a CSS variable used by mobile CSS
      document.documentElement.style.setProperty('--fp-bar-height', Math.round(height) + 'px');
      // put the button bottom to be height + a small gap
      var gap = 10; // px gap between button and bar
      try {
        backBtn.style.bottom = (height + gap) + 'px';
      } catch(e){}
    }
    // initial position
    updateBackBtnPosition();

    // keep in sync on resize/orientation
    var rt2;
    window.addEventListener('resize', function(){
      clearTimeout(rt2);
      rt2 = setTimeout(function(){ updateBackBtnPosition(); positionPriceForViewport(); }, 100);
    }, {passive:true});
    window.addEventListener('orientationchange', function(){ setTimeout(function(){ updateBackBtnPosition(); positionPriceForViewport(); }, 120); }, false);

    /* show/hide the back button in sync with floating bar visibility */
    function showBack(){ backBtn.classList.add('show'); backBtn.setAttribute('aria-hidden','false'); }
    function hideBack(){ backBtn.classList.remove('show'); backBtn.setAttribute('aria-hidden','true'); }

    // initial sync with shown flag
    if(typeof shown !== 'undefined' && shown) showBack();

    // monkey-patch showBar/hideBar to keep back button sync
    (function(){
      var _showBar = showBar;
      var _hideBar = hideBar;
      showBar = function(){
        _showBar();
        showBack();
        updateBackBtnPosition();
      };
      hideBar = function(){
        _hideBar();
        hideBack();
      };
    })();

    /* if the bar's height might change (e.g. mobile layout switch), observe it */
    if(bar){
      try {
        var resizeObs = new ResizeObserver(function(){ updateBackBtnPosition(); });
        resizeObs.observe(bar);
      } catch(e){}
    }

    /* --- End Back-to-top section --- */


  });
})();
